import React, { useEffect, useState } from 'react'
import {
  Box,
  Button,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TableSortLabel,
  TextField
} from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { compareStrings } from '../../utils/searchHelper'
import { Role, TrackingRows } from '@types'
import { userProfile } from '@views/profile/state/profileSlice'
import AnalystRejectedTableBody from './TableBody'
import {
  analystRejectedLoader,
  getRecoveredRejectedCases,
  selectRecoveredRejectedCases
} from './state/analystRejectedSlice'

export type Order = 'asc' | 'desc'

const AnalystRejectedView: React.FC = () => {
  const { role } = useSelector(userProfile)
  const rows: TrackingRows[] = useSelector(selectRecoveredRejectedCases)
  const { isLoading } = useSelector(analystRejectedLoader)
  const [order, setOrder] = useState<Order>('desc')
  const [isNumeric, setIsNumeric] = useState(false)
  const [isDateSort, setIsDateSort] = useState(true)
  const [orderBy, setOrderBy] = useState<string>('createdAt')
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const dispatch = useDispatch()
  const [searchRef, setSearchRef] = useState('')
  const [searchUser, setSearchUser] = useState('')

  const createSortHandler = (property: string, isNumeric: boolean) => () => {
    const isAsc = orderBy === property && order === 'asc'
    setOrder(isAsc ? 'desc' : 'asc')
    setOrderBy(property)
    setIsNumeric(isNumeric)
    setIsDateSort(property === 'studyDate')
  }

  useEffect(() => {
    dispatch(getRecoveredRejectedCases())
    setPage(0)
    setRowsPerPage(10)
  }, [])

  if (role !== Role.analista) {
    window.location.href = '/'
    return <div>Acceso denegado</div>
  }

  const handleChangePage = (_event: unknown, newPage: number) => {
    setPage(newPage)
  }

  const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10))
    setPage(0)
  }

  const filteredRows = rows?.filter(
    user => compareStrings(user.parentName, searchRef) && compareStrings(user.name, searchUser)
  )

  const handleClear = () => {
    setSearchUser('')
    setSearchRef('')
    setOrderBy('createdAt')
    setOrder('desc')
    setPage(0)
    dispatch(getRecoveredRejectedCases())
  }

  return (
    <>
      <div className="center_view padding_view">
        <TableContainer className="container-table" component={Paper}>
          <div className="table-container-search">
            <TextField
              id="search-user"
              label="Ahorrador"
              value={searchUser}
              onChange={event => setSearchUser(event.target.value)}
              variant="outlined"
              className="input-search"
            />
            <TextField
              id="search-ref"
              label="Referenciador"
              value={searchRef}
              onChange={event => setSearchRef(event.target.value)}
              variant="outlined"
              className="input-search"
            />
            <Box></Box>
            <Button type="submit" variant="contained" color="primary" onClick={handleClear}>
              Limpiar
            </Button>
          </div>
          <Table aria-label="analyst rejected table">
            <TableHead>
              <TableRow>
                <TableCell className="table_header" style={{ color: 'white' }} align="left">
                  <TableSortLabel
                    active={orderBy === 'name'}
                    direction={orderBy === 'name' ? order : 'asc'}
                    onClick={createSortHandler('name', false)}
                  >
                    AHORRADOR
                  </TableSortLabel>
                </TableCell>
                <TableCell className="table_header" style={{ color: 'white' }} align="left">
                  <TableSortLabel
                    active={orderBy === 'bankName'}
                    direction={orderBy === 'bankName' ? order : 'asc'}
                    onClick={createSortHandler('bankName', false)}
                    style={{ color: 'white' }}
                  >
                    BANCO
                  </TableSortLabel>
                </TableCell>
                <TableCell className="table_header" style={{ color: 'white' }} align="center">
                  <TableSortLabel
                    active={orderBy === 'createdAt'}
                    direction={orderBy === 'createdAt' ? order : 'asc'}
                    onClick={createSortHandler('createdAt', false)}
                  >
                    REGISTRADO
                  </TableSortLabel>
                </TableCell>
                <TableCell className="table_header" style={{ color: 'white' }} align="center">
                  <TableSortLabel
                    active={orderBy === 'studyDate'}
                    direction={orderBy === 'studyDate' ? order : 'asc'}
                    onClick={createSortHandler('studyDate', false)}
                  >
                    ESTUDIO
                  </TableSortLabel>
                </TableCell>
                <TableCell className="table_header" style={{ color: 'white' }} align="center"></TableCell>
              </TableRow>
            </TableHead>
            <AnalystRejectedTableBody
              users={filteredRows}
              rowsPerPage={rowsPerPage}
              order={order}
              page={page}
              isNumeric={isNumeric}
              isDateSort={isDateSort}
              orderBy={orderBy}
              isLoading={!!isLoading}
            />
          </Table>
          <div className="pagination-row">
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              count={
                rows?.filter(
                  user => compareStrings(user.parentName, searchRef) && compareStrings(user.name, searchUser)
                ).length
              }
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </div>
        </TableContainer>
      </div>
    </>
  )
}

export default AnalystRejectedView
